import { TrackingContext } from '@change-corgi/core-react/tracking';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { StripeLoader } from '#src/app/shared/components/payments';
import { PaypalProvider } from '#src/app/shared/hooks/payments';

import { Layout } from './layout';
import { MembershipModalStateContextProvider, useMembershipModalState } from './modalContext/modalState';
import type { ModalOptions, TrackingProperties } from './shared/types';

type Options = ModalOptions & {
	properties: TrackingProperties;
};

export const useMembershipAskModal = createModalHook<Options, { accepted: boolean; amount: number }>({
	name: 'MembershipModal',
	closeButton: false,
	closeOnEscape: false,
	closeOnClickOutside: false,
	variant: 'fullPage',
	body: function MembershipModalBody({ closeModal }) {
		const [{ amount }] = useMembershipModalState();

		return (
			<Layout
				onAccept={() => closeModal({ accepted: true, amount })}
				onDecline={() => closeModal({ accepted: false, amount })}
			/>
		);
	},
	decorator: ({ children, options: { properties, ...modalState } }) => {
		return (
			<MembershipModalStateContextProvider {...modalState}>
				<TrackingContext properties={properties}>
					<StripeLoader>
						<PaypalProvider>{children}</PaypalProvider>
					</StripeLoader>
				</TrackingContext>
			</MembershipModalStateContextProvider>
		);
	},
});
